import {assert} from 'wnd-util';

// TODO: Autogenerate this file based on data from webpack.overrides.js
//  OR just declare that they exist in a declaration file...

assert.assertExists(process.env.LOGGER_ENABLED, 'LOGGER_ENABLED must be configured');
export const LOGGER_ENABLED: boolean = process.env.LOGGER_ENABLED as any;

assert.assertExists(process.env.LOGGER_ENV, 'LOGGER_ENV must be configured');
export const LOGGER_ENV = process.env.LOGGER_ENV;

assert.assertExists(process.env.LOGGER_ACCESS_TOKEN, 'LOGGER_ACCESS_TOKEN must be configured');
export const LOGGER_ACCESS_TOKEN = process.env.LOGGER_ACCESS_TOKEN;

assert.assertExists(process.env.LOGGER_ENVIRONMENT, 'LOGGER_ENVIRONMENT must be configured');
export const LOGGER_ENVIRONMENT = process.env.LOGGER_ENVIRONMENT;

assert.assertExists(process.env.LOGGER_IGNORE_LIST, 'LOGGER_IGNORE_LIST must be configured');
export const LOGGER_IGNORE_LIST = process.env.LOGGER_IGNORE_LIST;

assert.assertExists(process.env.CLIENT_ID, 'CLIENT_ID must be configured for this to work');
export const CLIENT_ID = process.env.CLIENT_ID;

assert.assertExists(
  process.env.SELECTION_PRODUCT_NAME,
  'SELECTION_PRODUCT_NAME must be configured'
);
export const SELECTION_PRODUCT_NAME = process.env.SELECTION_PRODUCT_NAME;
assert.assertExists(process.env.WONSCORE_PRODUCT_NAME, 'WONSCORE_PRODUCT_NAME must be configured');
export const WONSCORE_PRODUCT_NAME = process.env.WONSCORE_PRODUCT_NAME;

assert.assertExists(process.env.BASE_URL, 'BASE_URL must be configured');
export const PRIVACY_POLICY_URL = process.env.BASE_URL;
